import React from "react";
import ReactDOM from "react-dom";
import LogRocket from "logrocket";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import config from "./Config";
import { NotificationManager } from "react-notifications";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: () => {
    console.log("Service Worker installed");
    // You can replace the console.log with your actual notification logic
    NotificationManager.success("New version available", "Success", 5000, () => {
      window.location.reload();
    });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (config.logrocket.enabled) {
  console.log("starting logrocket", config.logrocket.key);
  LogRocket.init(config.logrocket.key);
}

navigator.serviceWorker.addEventListener("message", (event) => {
  console.log("Service Worker message received:", event.data);
  if (event.data && event.data.type === "SERVICE_WORKER_INSTALLATION") {
    // Show a notification
    console.log("Service Worker installed", event.data.status);
    // You can replace the console.log with your actual notification logic
    NotificationManager.success("New version available", "Success", 5000, () => {
      navigator.serviceWorker.controller.postMessage({ type: "SKIP_WAITING" });
    });
  }
});
